import * as React from 'react';

const TableHead: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <thead>{children}</thead>;
};

export { TableHead };
